import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type AssignmentsProductManagePastRoute from 'teacher-ui-client/assignments/product/manage/past/route'
import type AssignmentsProductManagePastController from 'teacher-ui-client/assignments/product/manage/past/controller'
import { AssignmentsTable } from 'teacher-ui-client/components/assignments-admin/assignments-table/index'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'

interface Signature {
  Args: {
    model: ModelFor<AssignmentsProductManagePastRoute>
    controller: AssignmentsProductManagePastController
  }
}
export const AssignmentsManagePastPage: TOC<Signature> = <template>
  <AssignmentsTable
    @subscriptionType={{@model.subscriptionType}}
    @assignments={{@controller.assignments}}
    @assignmentScores={{@model.assignmentScores}}
    @showAssignmentAction={{@controller.showAssignment}}
    @closeAssignmentAction={{@controller.closeAssignment}}
    @selectedAssignment={{@controller.selectedAssignment}}
    @currentSortDirection={{@controller.sortDirection}}
    @currentSortColumn={{@controller.sortColumn}}
    @sortColumnAction={{@controller.sortColumnAction}}
    @openMode={{if @controller.selectedAssignment "show"}}
  />
  <BasePageSelector
    class="mx-2 my-4"
    @pageCount={{@controller.totalNumOfPages}}
    @itemCount={{@model.totalAssignments}}
  />
</template>

export default RouteTemplate(AssignmentsManagePastPage)
